var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerPrefrenceLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 282,
    viewBox: "0 0 282 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.731 137.728V126.438C161.731 122.389 158.637 117.912 154.851 116.497L138.426 110.341C135.694 109.321 131.217 109.321 128.485 110.341L112.06 116.53C108.274 117.945 105.18 122.422 105.18 126.438V150.895C105.18 154.779 107.748 159.881 110.875 162.218L125.029 172.784C127.333 174.562 130.394 175.418 133.456 175.418",
    stroke: "#00B894",
    strokeWidth: 5.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.622 168.833C153.893 168.833 159.788 162.938 159.788 155.667C159.788 148.395 153.893 142.5 146.622 142.5C139.35 142.5 133.455 148.395 133.455 155.667C133.455 162.938 139.35 168.833 146.622 168.833Z",
    stroke: "#00B894",
    strokeWidth: 5.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.065 172.124H163.095",
    stroke: "#00B894",
    strokeWidth: 5.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.991 97.7986C183.951 97.7854 183.932 97.7665 183.921 97.7502C183.908 97.7306 183.898 97.7028 183.898 97.6701C183.898 97.6375 183.908 97.6096 183.921 97.5901C183.932 97.5737 183.951 97.5549 183.991 97.5417L186.871 96.5947L186.714 96.1197L186.871 96.5947C187.213 96.482 187.482 96.2134 187.594 95.8709L188.541 92.9914C188.554 92.9513 188.573 92.9323 188.59 92.9212C188.609 92.9079 188.637 92.8984 188.67 92.8984C188.702 92.8984 188.73 92.9079 188.75 92.9212C188.766 92.9323 188.785 92.9513 188.798 92.9914L189.745 95.8709C189.858 96.2134 190.126 96.482 190.469 96.5947L193.348 97.5417C193.389 97.5549 193.408 97.5737 193.419 97.5901C193.432 97.6096 193.441 97.6375 193.441 97.6701C193.441 97.7028 193.432 97.7306 193.419 97.7502C193.408 97.7665 193.389 97.7854 193.348 97.7986L190.469 98.7456C190.126 98.8582 189.858 99.1269 189.745 99.4693L190.22 99.6255L189.745 99.4693L188.798 102.349C188.785 102.389 188.766 102.408 188.75 102.419C188.73 102.432 188.702 102.442 188.67 102.442C188.637 102.442 188.609 102.432 188.59 102.419C188.573 102.408 188.554 102.389 188.541 102.349L187.594 99.4693C187.482 99.1269 187.213 98.8582 186.871 98.7456L183.991 97.7986Z",
    fill: "#00B894",
    stroke: "#101C34"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.079 107.539C164.039 107.525 164.02 107.506 164.009 107.49C163.995 107.471 163.986 107.443 163.986 107.41C163.986 107.377 163.995 107.35 164.009 107.33C164.02 107.314 164.039 107.295 164.079 107.282L169.348 105.549C169.691 105.436 169.96 105.167 170.072 104.825L171.805 99.5553C171.818 99.5152 171.837 99.4962 171.854 99.4851C171.873 99.4719 171.901 99.4623 171.934 99.4623C171.966 99.4623 171.994 99.4719 172.014 99.4851C172.03 99.4962 172.049 99.5152 172.062 99.5553L173.795 104.825C173.908 105.167 174.176 105.436 174.519 105.549L179.788 107.282C179.829 107.295 179.848 107.314 179.859 107.33C179.872 107.35 179.881 107.377 179.881 107.41C179.881 107.443 179.872 107.471 179.859 107.49C179.848 107.506 179.829 107.525 179.788 107.539L174.519 109.272C174.176 109.384 173.908 109.653 173.795 109.995L172.062 115.265C172.049 115.305 172.03 115.324 172.014 115.335C171.994 115.348 171.966 115.358 171.934 115.358C171.901 115.358 171.873 115.348 171.854 115.335C171.837 115.324 171.818 115.305 171.805 115.265L170.072 109.995C169.96 109.653 169.691 109.384 169.348 109.272L164.079 107.539Z",
    fill: "#00B894",
    stroke: "#101C34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9346 172V180.026M104.124 174.895L98.5033 180.553M107 182H98.8954M104.124 189.237L98.2418 183.316M96.9346 192V183.974M89.8758 189.237L95.7582 183.316M87 182H95.2353M89.8758 174.895L95.7582 180.816",
    stroke: "black",
    strokeWidth: 0.833333
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_472_15846)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141,
    cy: 141,
    r: 53,
    fill: "#00B894",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_472_15846",
    x: 0.0999985,
    y: 0.0999985,
    width: 281.8,
    height: 281.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 43.95,
    result: "effect1_foregroundBlur_472_15846"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerPrefrenceLogo);
export default __webpack_public_path__ + "static/media/banner-prefrence-logo.08155f438454ec6c2f6426fe29cae6c7.svg";
export { ForwardRef as ReactComponent };